import type { TourDocumentView } from './types'

export const isTourDocumentCustomer = (
  document: Pick<TourDocumentView, 'canPay'>,
): boolean => document.canPay
